import { QueryClient } from 'react-query';
import { put, takeLatest } from 'redux-saga/effects';
import { Task, TaskAPI } from 'api/tasks';
import { FetchStatus, StoreActionProps } from 'data/core';
import { getQueryClientContext } from 'data/core/sagas/query-client';
import { getProjectDependencyMapKey } from 'queries/common';
import { logger } from 'services';
import { CreateTaskActionPayload, createTaskSagaAction } from '../actions';
import { saveTasks } from '../slice';

function* createTaskSaga(
  action: StoreActionProps<CreateTaskActionPayload>,
): Generator {
  const { payload } = action;

  const queryClient = (yield getQueryClientContext()) as QueryClient;

  const { projectId, task } = payload;

  try {
    const newTask = (yield TaskAPI.createTask(projectId, task)) as Task;

    yield queryClient.invalidateQueries(getProjectDependencyMapKey(projectId));

    yield put(saveTasks({ data: [newTask], fetchStatus: FetchStatus.Loaded }));
  } catch (error) {
    logger.error('create task failed', { error });
  }
}

export function* watchCreateTaskSaga(): Generator {
  yield takeLatest(createTaskSagaAction.type, createTaskSaga);
}
